import React from "react";
import { Line, Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Filler,
    Tooltip,
    Legend,
    BarElement,
} from "chart.js";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Filler, Tooltip, Legend, BarElement);

const RevenueChart = ({ salesData }) => {
    // Tính toán tăng trưởng
     const salesDataWithGrowth = salesData.map((data, index) => {
        const roundedSales = Math.ceil(data.sales / 100000) * 100000;
        const growth =
            index === 0
                ? 0
                : ((data.sales - salesData[index - 1].sales) / salesData[index - 1].sales) * 100;

        return { ...data, roundedSales, growth: growth.toFixed(2) };
    });

    const data = {
        labels: salesDataWithGrowth.map((data) => data.month),
        datasets: [
            {
                label: "Doanh thu (VND)",
                data: salesDataWithGrowth.map((data) => data.sales),
                borderColor: "rgb(255, 99, 132)",
                borderWidth: 3,
                pointBorderColor: "rgb(255, 99, 132)",
                pointBorderWidth: 3,
                tension: 0.3,
                fill: false,
                type: "line", // Biểu đồ đường cho doanh thu
                yAxisID: 'y1', // Trục Y cho doanh thu
            },
            {
                label: "Tăng trưởng (%)",
                data: salesDataWithGrowth.map((data) => data.growth), // Dữ liệu tăng trưởng
                borderColor: "#36A2EB", 
                backgroundColor: "rgba(54, 162, 235, 0.2)", // Màu nền cho cột
                borderWidth: 2,
                fill: true,
                type: "bar", // Biểu đồ cột cho tăng trưởng
                barThickness: 10, // Điều chỉnh độ dày của các cột
                categoryPercentage: 0.5,
                yAxisID: 'y2', // Trục Y cho tỷ lệ tăng trưởng
            },
        ],
    };

    // Tính toán maxSales và làm tròn xuống bội số của 10
    const maxSales = Math.max(...salesDataWithGrowth.map((data) => data.roundedSales));
    const roundedMaxSales = Math.ceil(maxSales / 10) * 10; // Làm tròn lên bội số của 10
    
    // Tính stepSize sao cho có 6 bước đều nhau và giá trị stepSize là bội số của 10
    let stepSize = Math.ceil((roundedMaxSales - 0) / 5); // Chia cho 5 để có 6 mức (0, stepSize, 2*stepSize, ...)
    if (stepSize % 10 !== 0) {
        stepSize = Math.ceil(stepSize / 10) * 10; // Đảm bảo stepSize là bội số của 10
    }
    
    const options = {
        plugins: {
            datalabels: {
                display: false, 
            },
            legend: {
                position: "top", // Đặt legend ở trên cùng
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y1: {
                grid: {
                    display: true, // Không hiển thị gridlines cho trục X
                    color: 'rgba(245, 252, 252)'
                },
                
                ticks: {
                    font: {
                        size: 13,
                        weight: "bold",
                    },
                    stepSize: stepSize, // Điều chỉnh bước nhảy của trục Y doanh thu
                    max: roundedMaxSales, // Đảm bảo giá trị max là bội số của 10
                    callback: function (value) {
                        if (value >= 1000000) {
                            return (value / 1000000) + "tr"; 
                        } 
                        else if (value >= 1000) {
                            return (value / 1000) + "K"; 
                        } 
                        else {
                            return value; 
                        }
                    }
                },
                title: {
                    display: true,
                    text: "Doanh thu (VND)",
                    color: "rgb(255, 99, 132)",
                    padding: {
                        bottom: 10,
                    },
                    font: {
                        size: 18,
                    },
                },
                min: 0
            },
            y2: {
                grid: {
                    display: true, // Không hiển thị gridlines cho trục
                    color: 'rgba(240, 240, 240, 0.5)'
                },
                ticks: {
                    font: {
                        size: 13,
                        weight: "bold",
                    },
                    stepSize: 10, // Giới hạn độ chia cho tỷ lệ tăng trưởng (growth) ở trục Y phụ
                },
                title: {
                    display: true,
                    text: "Tăng trưởng (%)",
                    color: "cornflowerblue",
                    padding: {
                        bottom: 10,
                    },
                    font: {
                        size: 18,
                    },
                },
                min: 0,
                max: 100, // Giới hạn tối đa cho tăng trưởng
                position: 'right', // Đặt trục Y phụ ở phía bên phải
            },
            x: {
                grid: {
                    display: false, // Không hiển thị gridlines cho trục X
                },
                ticks: {
                    font: {
                        size: 13,
                        weight: "bold",
                    },
                },
                title: {
                    display: true,
                    text: "Tháng",
                    padding: {
                        top: 10,
                    },
                    font: {
                        size: 18,
                    },
                },
            },
        },
    };
    
    

    return (
        <div
            style={{
                width: "100%",
                height: "300px",
                position: "relative",
                padding: "20px",
                cursor: "pointer",
            }}
        >
            <Line data={data} options={options} />
        </div>
    );
};

export default RevenueChart;
